import React from "react";
import KleoStats from "./KleoStats";

export default function App() {
	return (
		<div>
			<KleoStats />
			{/* Other components */}
		</div>
	);
}
